import angular from 'angular';
import FooterDirective from './footer/ws-footer';
import DeprecatedModalController from './modal-deprecated/ws-modal.controller';
import DeprecatedModalService from './modal-deprecated/ws-modal.service';
import ModalTriggerService from './modal/modal-trigger.service';
import ModalComponent from './modal';
import NotificationDirective from './notifications/ws-notification';
import SecondaryNavDirective from './secondary-nav/ws-secondary-nav';

const injectorName = 'ws.common.layout';
export default injectorName;

angular.module(injectorName, [])
  .directive('wsFooter', FooterDirective)
  .component('wsModal', ModalComponent)
  .controller('wsModalController', DeprecatedModalController)
  .service('wsModalService', DeprecatedModalService)
  .service('wsModalTriggerService', ModalTriggerService)
  .directive('wsNotification', NotificationDirective)
  .directive('wsSecondaryNav', SecondaryNavDirective);



// WEBPACK FOOTER //
// ./src/layout/index.js